module.exports = __webpack_public_path__ + "static/media/6.4a99d474.png";